import React, { FC } from 'react';
import { IPollGetByIdResponse, TQuestionInPoll } from 'shared/types/poll.types';
import { Button } from 'antd';
import { TPollAnswer } from 'features/poll/questionDrawer/QuestionDrawer';
import style from './index.module.scss';

type TQuestionInPollInfoProps = {
  currentPoll: IPollGetByIdResponse;
  totalAnswers: number;
  onDrawerOpen: (answerId: number | null, questionId: number, answer?: TPollAnswer, question?: TQuestionInPoll) => void;
};

const QuestionInPollInfo: FC<TQuestionInPollInfoProps> = ({ currentPoll, onDrawerOpen, totalAnswers }) => {
  const leftPercents = (answer: TPollAnswer): string => {
    if (!answer?.respondentsCount && !answer?.respondentsCount) {
      return '0%';
    }
    return totalAnswers ? Math.round((answer?.respondentsCount / totalAnswers) * 100) + '%' : 0 + '%';
  };
  return (
    <>
      {currentPoll.questions.map(question => (
        <div className={style.results} key={question.id}>
          <div className={style.question}>
            <p>{question.title}</p>
            <div className={style.list}>
              {question.answers.map(item => (
                <div className={style.result} key={item?.id}>
                  <div className={style.row}>
                    <div className={style.option}>{item?.value}</div>
                    <div className={style.percents}>{leftPercents(item)}</div>
                  </div>
                </div>
              ))}
              {question.isYourAnswer ? (
                <div className={style.result}>
                  <div className={style.row}>
                    <div className={style.option}>Свой ответ</div>
                    <div className={style.percents}>
                      {leftPercents({
                        id: 0,
                        value: '',
                        respondentsCount: Number(question?.personalResponsesCount),
                      })}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <div className={style['row-buttons']}>
            {question.answers.map(item => (
              <div className={style.result} key={item?.id}>
                <Button onClick={() => onDrawerOpen(item?.id, Number(question.id), item, question)}>Результаты</Button>
              </div>
            ))}
            {question.isYourAnswer ? (
              <div className={style.result} key={'isYourAnswer'}>
                <Button onClick={() => onDrawerOpen(null, Number(question.id), undefined, question)}>Результаты</Button>
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </>
  );
};

export default QuestionInPollInfo;
